import { AMINO_ACID_COLORS, NUCLEOTIDE_COLORS, withAlpha } from "@lib/colors";

type CodonEntry = {
  aminoAcid: string;
  codon: string;
};

const SEQUENCE: (CodonEntry | null)[] = [
  { aminoAcid: "P", codon: "CCA" },
  { aminoAcid: "R", codon: "CGT" },
  { aminoAcid: "I", codon: "ATC" },
  { aminoAcid: "V", codon: "GTA" },
  { aminoAcid: "A", codon: "GCA" },
  { aminoAcid: "T", codon: "ACT" },
  { aminoAcid: "E", codon: "GAG" },
  null,
  { aminoAcid: "B", codon: "AAC" },
  { aminoAcid: "E", codon: "GAA" },
  { aminoAcid: "T", codon: "ACC" },
  { aminoAcid: "A", codon: "GCT" },
];

type NucleotideItem = { kind: "nt"; base: string; key: string };
type GapItem = { kind: "gap"; cols: number; key: string };
type AminoAcidItem = { kind: "aa"; aminoAcid: string; key: string };

type NucleotideRowItem = NucleotideItem | GapItem;
type AminoAcidRowItem = AminoAcidItem | GapItem;

function buildRows(): {
  nucleotideRow: NucleotideRowItem[];
  aminoAcidRow: AminoAcidRowItem[];
  cols: number;
} {
  const nucleotideRow: NucleotideRowItem[] = [];
  const aminoAcidRow: AminoAcidRowItem[] = [];
  let cols = 0;
  let position = 0;

  for (const entry of SEQUENCE) {
    if (entry === null) {
      nucleotideRow.push({ kind: "gap", cols: 2, key: `nt-gap-${position}` });
      aminoAcidRow.push({ kind: "gap", cols: 2, key: `aa-gap-${position}` });
      cols += 2;
    } else {
      for (const base of entry.codon) {
        nucleotideRow.push({ kind: "nt", base, key: `nt-${position}` });
        position++;
      }
      aminoAcidRow.push({
        kind: "aa",
        aminoAcid: entry.aminoAcid,
        key: `aa-${position}`,
      });
      cols += 3;
    }
  }

  return { nucleotideRow, aminoAcidRow, cols };
}

const { nucleotideRow, aminoAcidRow, cols } = buildRows();

export function CodonSequence() {
  return (
    <div
      className="grid gap-y-0.5 overflow-x-auto font-mono text-lg"
      style={{
        gridTemplateColumns: `repeat(${cols}, 1ch)`,
      }}
    >
      {nucleotideRow.map((item) =>
        item.kind === "gap" ? (
          <span key={item.key} className="col-span-2" />
        ) : (
          <span
            key={item.key}
            className="text-center font-medium text-sm"
            style={{
              backgroundColor: withAlpha(NUCLEOTIDE_COLORS[item.base], 0.6),
            }}
          >
            {item.base}
          </span>
        ),
      )}

      {aminoAcidRow.map((item) =>
        item.kind === "gap" ? (
          <span key={item.key} className="col-span-2" />
        ) : (
          <span
            key={item.key}
            className="col-span-3 text-center font-semibold"
            style={{
              backgroundColor: withAlpha(
                AMINO_ACID_COLORS[item.aminoAcid],
                0.6,
              ),
            }}
          >
            {item.aminoAcid}
          </span>
        ),
      )}
    </div>
  );
}
